window._cmp = {};
window._svc = {};

import MainComponent from '../src/components/main.component';

